<template>
  <transition-group
    :tag="tag"
    name="slide-list-transition"
    v-on:before-leave="beforeLeave"
  >
    <slot />
  </transition-group>
</template>

<script>
export default {
  name: 'slide-list-transition',
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  },
  methods: {
    beforeLeave (el) {
      el.style.width = `${el.offsetWidth}px`
      el.style.position = 'absolute'
    }
  }
}
</script>

<style lang='scss'>
.slide-list-transition-item {
  display: inline-block;
  margin-right: 10px;
}
.slide-list-transition-enter-active, .slide-list-transition-leave-active {
  transition: all 250ms;
}
.slide-list-transition-enter, .slide-list-transition-leave-to {
  opacity: 0;
}
.slide-list-transition-leave-to {
  transform: translate(30px, -15px);
}
.slide-list-transition-enter {
  transform: translateX(30px);
}
.slide-list-transition-leave-active {
  position: absolute;
}
.slide-list-transition-move {
  transition: all 250ms;
}
</style>
